// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2960":"accb1037","4794":"accb1037","5691":"accb1037","8992":"accb1037"}[chunkId] + ".chunk.css";
};